import { render, staticRenderFns } from "./icon-three-arrows.vue?vue&type=template&id=38f392a0"
import script from "./icon-three-arrows.vue?vue&type=script&lang=ts"
export * from "./icon-three-arrows.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports